import React, { Component } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.css';

const SHOP_URL = 'https://shop.tathatagolf.com';
const FALLBACK_IMAGE_URL = 'https://d27vybgvtr1dba.cloudfront.net/online-follow-ups/hero.jpg';

class ShopifyWidget extends Component {
  state = {
    loading: true,
    loaded: false,
    products: [],
  };

  componentDidMount() {
    fetch(`${SHOP_URL}/collections/app-featured-products/products.json`)
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('Could not fetch products');
      })
      .then(response => {
        this.setState({
          loading: false,
          loaded: true,
          products: response.products,
        });
      })
      .catch(error => {
        this.setState({
          loading: false,
        });
      });
  }

  renderNoContent() {
    return (
      <div className="shopify--widget">
        <div className="shopify--widget__header">
          <h4>Visit Our Shop</h4>
        </div>
        <div className="shopify--widget__product-img" style={{ backgroundImage: `url("${FALLBACK_IMAGE_URL}")` }} />
        <div className="shopify--widget__button-wrapper">
          <a className="button button--theme--outline" href={SHOP_URL} target="_blank" rel="noopener noreferrer">
            View Products
          </a>
        </div>
      </div>
    );
  }

  render() {
    const { loading, products } = this.state;

    if (loading || !products.length) {
      return this.renderNoContent();
    }

    const slides = products.map((product, index) => (
      <div key={`product-${index}`}>
        <div
          className="shopify--widget__product-img"
          style={{
            backgroundImage: `url("${product.images.length ? product.images[0].src : FALLBACK_IMAGE_URL}")`,
          }}
        />
        <div className="shopify--widget__product--info">
          <h4 className="shopify--widget__product-title">{product.title}</h4>
        </div>
        <div className="shopify--widget__button-wrapper">
          <a
            className="button button--theme--outline"
            href={`${SHOP_URL}/products/${product.handle}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            View Product
          </a>
        </div>
      </div>
    ));

    return (
      <div className="shopify--widget">
        <div className="shopify--widget__header">
          <h4>Visit Our Shop</h4>
        </div>
        <Carousel className="" infiniteLoop showArrows showIndicators={false} showStatus={false} showThumbs={false}>
          {slides}
        </Carousel>
      </div>
    );
  }
}

export default ShopifyWidget;



// WEBPACK FOOTER //
// ./src/subscription/dashboard/ShopifyWidget.js